import { Box, Button, Container, Paper, Typography } from "@mui/material";

export default function Home() {
  return (
    <Container
      sx={{ display: "flex", flexDirection: "column", gap: 2, padding: 2 }}
    >
      <Typography variant="h4">Daily Inventory Form</Typography>
      <Paper
        sx={{ padding: 2, display: "flex", flexDirection: "column", gap: 1 }}
      >
        <Typography variant="h6">Choose a time</Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button variant="contained" href="/inventory/10h">
            10AM
          </Button>
          <Button variant="contained" href="/inventory/12h">
            12PM
          </Button>
          <Button variant="contained" href="/inventory/20h">
            8PM
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
